import { render, staticRenderFns } from "./TeamGoalRow.vue?vue&type=template&id=4d3ebc91&scoped=true"
import script from "./TeamGoalRow.vue?vue&type=script&lang=ts"
export * from "./TeamGoalRow.vue?vue&type=script&lang=ts"
import style0 from "./TeamGoalRow.vue?vue&type=style&index=0&id=4d3ebc91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3ebc91",
  null
  
)

export default component.exports